import Vue from 'vue'
import Router from 'vue-router'
//通信总线
import Bus from 'common/js/bus.js';
//axios
import axios from 'axios'

axios.defaults.withCredentials = true
import apiConfig from '../common/js/api_config'

console.log("接口配置：")
console.log(apiConfig)

//业务组件
import user from 'pages/user'

const home = () => import('pages/home')




import service from 'pages/service'
import test from 'pages/test'
import personal from 'pages/personal'
import datanalysis from 'pages/datanalysis'
import count from 'components/datanalysis/count'
import oneTable from 'components/datanalysis/oneTable'
import notice from 'pages/notice'
import digit from 'pages/digit'

//vuex
import store from 'store/index';


Vue.use(Router);

//实例化路由
let rt = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/user',
      component: user,
      children: [
        {
          path: '/home',
          component: home
        },
        {
          path: '/service',
          component: service
        },
        {
          path: '/personal',
          component: personal
        },
        {
          path: '/notice',
          component: notice
        },
        {
          path: '/digit',
          component: digit
        },
        {
          path: '/datanalysis',
          component: datanalysis,
          children: [
            {
              path: '/datanalysis/count',
              component: count,
            },
            {
              path: '/datanalysis/onetable',
              component: oneTable,
            }
          ]
        },
        {
          path: '/test',
          component: test
        }
      ]
    }
  
  ]
});


/***
 * 基础方法
 */

//用于生成uuid
function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

/***
 * 路由守卫
 */


rt.beforeEach(async (to, from, next) => {
  if (to.path === '/website') {
    window.open("http://www.sxbac.net.cn/", "_blank")
    return
  }
  if (to.path === '/jiuban'){
    window.open("http://ehall.sxphc.cn:8086/portal/index.html#/home/student", "_blank")
    return
  }
  store.commit("updateLoadingStatus", true);
  next()
  //如果获取到用户登录状态直接跳转
  if (store.getters.getUserLoginStatus) {
    next();
    return;
  }
  
  
  //如果获取不到用户登录状态则请求用户状态
  let userInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_userInfo").catch(() => {
    //TODO:重定向错误页
  });
  
  
  //判断返回的状态码
  if (!userInfo.data.status) {
    // let url = window.location.origin + window.location.pathname + '$' + to.path
    let url = window.location.origin + window.location.pathname + '$' + '/service'
    let targetURL = apiConfig.REQUEST_URL + "/shall/cgi-bin/login?url=" + url
    console.log("targetURL", targetURL)
    location.replace(targetURL)
    return;
  } else {
    store.commit("updateUserInfo", userInfo.data.data[0]);
    store.commit("updatePhotourl", userInfo.data.url)
    console.log("%c 已登录", "font-size:50px;color:#f60")
  }
  next();
  Bus.$emit('userInfoReady', {})
});
rt.afterEach(async (to, from) => {
  store.commit("updateLoadingStatus", false);
  
  
  //首页不显示侧栏菜单
  if (to.path.indexOf("/home") !== -1) {
    store.commit("toggleSideMenuShow", false);
  } else {
    store.commit("toggleSideMenuShow", true);
  }
  
  //个人中心不显示顶栏头像
  if (to.path.indexOf("/personal") !== -1) {
    store.commit("toggleTopAvatarShow", false);
  } else {
    store.commit("toggleTopAvatarShow", true);
  }
  
  
  try {
    let countResp = await axios.post(apiConfig.REQUEST_URL + "/shall/f_accessInfo?uuid=" + guid() + '&url=' + window.location.href + '&ratio=' + window.screen.width + "*" + window.screen.height);
  } catch (e) {
    console.log("请求f_accessInfo出错：", e);
  }
  
  
});
//导出路由实例
export default rt;



// WEBPACK FOOTER //
// ./src/router/index.js